<script setup>
import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import _ from 'lodash'


// Store, route, notification
const store = useStore()
const instance = getCurrentInstance()
const root = instance.proxy.$root
const router = useRouter()


// Props
const props = defineProps({
	items: {
		type: Object,
		required: true
	},
	showTotalItems: {
		type: Boolean,
		default: true
	},
})


// Refs


// Computed
const streamsNumberComputed = computed(() => {
	return props.items.filter((item) => item.type === 'live').length
})
const vodFilesNumberComputed = computed(() => {
	return props.items.filter((item) => item.type === 'vod').length
})
// Hooks
onMounted(async () => {
	
})

onUnmounted(() => {
	
})


// Methods

</script>

<template>
	<ul class="flex items-center gap-1 text-tiny text-surface-8" v-if="items?.length > 0">
		<li v-if="showTotalItems">
			{{ items.length }} item{{ items.length !== 1 ? 's' : '' }}
		</li>
		<li :class="showTotalItems ? 'before:content-[\'•\'] before:mr-1' : ''" v-if="streamsNumberComputed">
			{{ streamsNumberComputed }} Livestream{{ streamsNumberComputed !== 1 ? 's' : '' }}
		</li>
		<li :class="showTotalItems || streamsNumberComputed ? 'before:content-[\'•\'] before:mr-1' : ''" v-if="vodFilesNumberComputed">
			{{ vodFilesNumberComputed }} VOD{{ vodFilesNumberComputed !== 1 ? 's' : '' }}
		</li>
	</ul>
	<p class="text-sm text-surface-8" v-else-if="showTotalItems">
0 items
	</p>
</template>

<style scoped></style>
